import { Loading, Message, MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router'

/**
 * 'DefaultActions'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
export default {
  delete (resource) {
    return {
      label: 'Eliminar',
      icon: 'icon-trash',
      show () { return store.getters['profile/can'](resource + '.destroy') },
      onClick: (row) => {
        MessageBox.confirm('¿Está seguro que desea eliminar este elemento?')
          .then((e) => {
            let loader = Loading.service()
            store.dispatch(resource + '/delete', row.id)
              .then((response) => {
                Message.success('El elemento se ha eliminado con éxito')
                return store.dispatch(resource + '/query', router.currentRoute.query)
              }).catch((e) => {
                console.error(e)
                Message.success('Ha surgido un problema al eliminar el elemento')
              }).finally(() => {
                loader.close()
              })
          })
          .catch()
      }
    }
  },
  edit (resource) {
    return {
      label: 'Editar',
      icon: 'icon-edit',
      show () { return store.getters['profile/can'](resource + '.update') },
      onClick: (row) => {
        router.push({name: resource + '-edit', params: {id: row.id}})
      }
    }
  },
  create (resource) {}
}



// WEBPACK FOOTER //
// ./src/helpers/default-actions.js